export const themes = [
  {
    type: 'h1',
    label: 'Heading 1',
    font: {
      style: {
        bold: false,
        italic: false,
        underline: false
      },
      fontSize: '67',
      fontFamily: 'Montserrat,sans-serif',
      lineSpacing: '1.2',
      letterSpacing: '0',
      color: {
        type: 'solid',
        r: 0,
        g: 0,
        b: 0,
        a: 1
      }
    }
  },
  {
    type: 'h2',
    label: 'Heading 2',
    font: {
      style: {
        bold: false,
        italic: false,
        underline: false
      },
      fontSize: '50',
      fontFamily: 'Montserrat,sans-serif',
      lineSpacing: '1.2',
      letterSpacing: '0',
      color: {
        type: 'solid',
        r: 0,
        g: 0,
        b: 0,
        a: 1
      }
    }
  },
  {
    type: 'h3',
    label: 'Heading 3',
    font: {
      style: {
        bold: false,
        italic: false,
        underline: false
      },
      fontSize: '37',
      fontFamily: 'Montserrat,sans-serif',
      lineSpacing: '1.2',
      letterSpacing: '0',
      color: {
        type: 'solid',
        r: 0,
        g: 0,
        b: 0,
        a: 1
      }
    }
  },
  {
    type: 'h4',
    label: 'Heading 4',
    font: {
      style: {
        bold: false,
        italic: false,
        underline: false
      },
      fontSize: '28',
      fontFamily: 'Montserrat,sans-serif',
      lineSpacing: '1.2',
      letterSpacing: '0',
      color: {
        type: 'solid',
        r: 0,
        g: 0,
        b: 0,
        a: 1
      }
    }
  },
  {
    type: 'h5',
    label: 'Heading 5',
    font: {
      style: {
        bold: false,
        italic: false,
        underline: false
      },
      fontSize: '21',
      fontFamily: 'Montserrat,sans-serif',
      lineSpacing: '1.2',
      letterSpacing: '0',
      color: {
        type: 'solid',
        r: 0,
        g: 0,
        b: 0,
        a: 1
      }
    }
  },
  {
    type: 'h6',
    label: 'Heading 6',
    font: {
      style: {
        bold: false,
        italic: false,
        underline: false
      },
      fontSize: '16',
      fontFamily: 'Montserrat,sans-serif',
      lineSpacing: '1.2',
      letterSpacing: '0',
      color: {
        type: 'solid',
        r: 0,
        g: 0,
        b: 0,
        a: 1
      }
    }
  },
  {
    type: 'p',
    label: 'Paragraph',
    font: {
      style: {
        bold: false,
        italic: false,
        underline: false
      },
      fontSize: '16',
      fontFamily: 'Montserrat,sans-serif',
      lineSpacing: '1.2',
      letterSpacing: '0',
      color: {
        type: 'solid',
        r: 0,
        g: 0,
        b: 0,
        a: 1
      }
    }
  }
];
